module.exports = __webpack_public_path__ + "static/media/game-edition-desktop.55a3892a.svg";